import React, { useContext } from "react";
import SectionHeader from "../../partials/SectionHeader";
import { DataContext } from "../../../data";
import ProjectTile from "../../partials/ProjectTile";
import { CodeIcon } from '@heroicons/react/solid';
import { useScrollReveal } from "../../../hooks/useScrollReveal";


export default function Projects() {
  const { home, projects } = useContext(DataContext);
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="projects" className="text-text-color body-font">
      <div className="container px-5 py-5 mx-auto text-center lg:px-40">
        <SectionHeader {...{ title: home.projects.title, icon: <CodeIcon/>, 'description': home.projects.description }} />
        <div ref={ref} className={`flex flex-wrap -m-4 scroll-reveal${isVisible ? ' visible' : ''}`}>
          {projects.map((project) => (
            <ProjectTile key={`pro-${project.id}`}  {...project} />
          ))}
        </div>
      </div>
    </section>
  );
}
